import { periodKeyToDateRange } from '@/helpers/ukTaxYear'

/** e.g. 2019-2020 → 2019–20 */
export function periodKeyToTaxYearLabel(periodKey: string): string {
  const parts = periodKey.split('-').map((p) => parseInt(p, 10))
  if (parts.length < 2 || parts.some((n) => Number.isNaN(n))) return periodKey
  return `${parts[0]}–${String(parts[1]).slice(-2)}`
}

export function periodKeyToTaxYearTitle(periodKey: string): string {
  return `${periodKeyToTaxYearLabel(periodKey)} Tax Year`
}

export { periodKeyToDateRange }
